"use client"

/**
 * @deprecated Import from '@/hooks/auth' instead
 * This file re-exports for backward compatibility
 */

export { useAuth } from './auth/use-auth';
export type { AuthUser } from './auth/use-auth';
